import { Flex, Input, Typography } from 'antd';
import type { FC } from 'react';

const { Text } = Typography;

type Props = {
  value: number;
  onChange: (count: number) => void;
  max?: number;
  min?: number;
  label: string;
  icon?: React.ReactNode;
};

export const InputCountForm: FC<Props> = ({ value, onChange, label, max, min, icon }) => {
  return (
    <Flex align="middle" gap={5}>
      <Input
        type="number"
        value={value}
        onChange={({ target }) => {
          onChange(Number.parseInt(target.value, 10));
        }}
        max={max}
        min={min || 0}
        style={{ width: '60px', marginRight: '8px' }}
      />
      {icon && <div style={{ alignContent: 'center' }}>{icon}</div>}
      <Text strong style={{ alignContent: 'center' }}>
        {label}
      </Text>
    </Flex>
  );
};
